export default "__VITE_ASSET__B7qK8NhI__"